<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd" icon="plus">新建</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="deleteArea(record)">删除</a>
        </div>
      </template>
    </s-table>
    <!-- 编辑/新增区域 -->
    <a-modal
      :title="modal_title"
      :width="800"
      v-model="visible"
      okText='提交'
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='区域名称'
          fieldDecoratorId="name"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写区域名称' }],
            initialValue: mdl.name,
          }"
        >
          <a-input placeholder='区域名称' />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getAreaList, updateArea, deleteArea } from '@/api/area'

export default {
  name: 'Area',
  components: {
    STable
  },
  data() {
    return {
      visible: false,
      modal_title: '添加区域',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      queryParam: {
        sort: {
          field: 'id',
          reverse: true
        }
      },
      // 表头
      columns: [
        {
          title: '区域ID',
          dataIndex: 'id'
        },
        {
          title: '区域名称',
          dataIndex: 'name',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getAreaList(Object.assign(params, this.queryParam)).then(res => {
          console.log(res);
          return res
        })
      },
    }
  },
  methods: {
    handleAdd() {
      this.mdl = {}
      this.visible = true
    },
    handleEdit(record) {
      this.modal_title = '修改区域'
      this.mdl = Object.assign({}, record)
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          updateArea({...values,id: this.mdl.id}).then(res => {
            this.$refs.table.refresh()
            this.$message.success('操作成功')
            this.form.resetFields()
            this.visible = false
          })
        }
      })
    },
    handleCancel () {
      this.form.resetFields()
      this.visible = false
    },
    // eslint-disable-next-line
    deleteArea (row) {
      const _this = this
      this.$confirm({
        title: '警告',
        content: '真的要删除吗?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteArea(row.id).then(res => {
             _this.$refs.table.refresh()
            _this.$message.success('删除成功')
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
  }
}
</script>
<style scoped>
.add-btn {
  margin-bottom: 10px;
}
</style>
